import React from 'react';
import { motion } from 'framer-motion';

const BuilderSection: React.FC = () => {
  return (
    <section id="builder" className="relative py-32 px-6 sm:px-8 lg:px-12 border-t border-[#1F1F2E]/50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 md:gap-24 items-start">
          {/* Left */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#3B82F6]/50 mb-4 block">Program</span>
            <h2 className="font-space-grotesk text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[0.95]">
              Builder in
              <br />
              Residence
            </h2>
          </motion.div>

          {/* Right */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <p className="text-[#A1A1AA] leading-relaxed text-base">
              Each product vertical is structured as its own business within Noa Labs. We provide the distribution (2,400 dealer rooftops), the data (decades of transactional history), and the infrastructure (existing DMS/CRM integrations). You bring the technical vision and execution.
            </p>

            <div className="space-y-4">
              <div className="p-6 rounded-xl border border-[#1F1F2E]/60 bg-[#0F0F18]/50">
                <h3 className="text-white font-semibold text-sm mb-2.5">What you get</h3>
                <p className="text-[#A1A1AA]/60 text-sm leading-relaxed">
                  Joint venture equity in your vertical. Revenue sharing from day one of monetization. A founding team budget. Access to 2,400 dealerships without a single cold call.
                </p>
              </div>

              <div className="p-6 rounded-xl border border-[#1F1F2E]/60 bg-[#0F0F18]/50">
                <h3 className="text-white font-semibold text-sm mb-2.5">Who we're looking for</h3>
                <p className="text-[#A1A1AA]/60 text-sm leading-relaxed">
                  Technical founders, product leaders, and senior engineers who want to build category-defining products with built-in distribution.
                </p>
              </div>
            </div>

            <button
              onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center gap-2 text-sm text-[#3B82F6]/70 hover:text-[#3B82F6] transition-colors group"
            >
              See Open Verticals
              <span className="group-hover:translate-y-1 transition-transform">↓</span>
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BuilderSection;
